module.exports = __webpack_public_path__ + "img/29.fixed_mirro.4903bb74.svg";